import React, { useRef, useEffect, useState } from "react";
import downArrow from "../../../assets/downwardArrow.svg";

function Accordion({
  accordionKey,
  headerContent,
  innerContent,
  isOpen,
  onToggle,
  colourStripe = "bg-[#91CAFF]",
}: any) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState("0px");

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        setMaxHeight(`${contentRef.current.scrollHeight}px`);
      } else {
        setMaxHeight("0px");
      }
    }
  }, [isOpen, innerContent]);

  return (
    <div className={`${colourStripe}  ps-1.5 rounded-2xl`}>
      <div
        key={accordionKey}
        className={`flex flex-col my-4 shadow-md rounded-2xl cursor-pointer bg-white transition-all duration-200 ${
          isOpen ? "rounded-t-2xl border-b-0" : "rounded-2xl"
        }`}
      >
        {/* Header */}
        <div className={`flex items-center justify-between px-4 py-4`}>
          <div className="flex items-center gap-2 w-full">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onToggle?.();
              }}
              className="p-0 m-0 bg-transparent border-0 cursor-pointer"
              aria-label={isOpen ? "Collapse" : "Expand"}
            >
              <img
                src={downArrow}
                alt=""
                className={`w-[18px] transform transition-transform duration-300 ${
                  isOpen ? "" : "rotate-[-90deg]"
                }`}
              />
            </button>
            {headerContent}
          </div>
        </div>

        {/* Collapsible Content */}
        <div
          ref={contentRef}
          style={{
            maxHeight,
            transition: "max-height 0.3s ease",
            overflow: "hidden",
          }}
          className="bg-white rounded-b-2xl"
        >
          <div className="px-4 py-2 h-auto max-h-none overflow-y-scroll">
            {innerContent}
          </div>
        </div>
      </div>{" "}
    </div>
  );
}

export default Accordion;
